import script from "./UsersFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersFilters.vue?vue&type=script&setup=true&lang=js"

import "./UsersFilters.vue?vue&type=style&index=0&id=28c77b01&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c77b01"]])

export default __exports__